import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  mode: 'history',
  //base: '/vv',
  routes: [


    //================================== 首页
    {
      name: 'Index',
      path: '/',
      component: () => import('../views/index/Index'),
      meta: {
        title: '首页',
        requireLogin: false,
        index: 1 //判断index来决定页面的层级
      },
      children: [
        {
          name: 'IndexBrand',
          path: 'index_brand',
          component: () => import('../views/index/IndexBrand'),
          meta: {
            title: '品牌大全',
            requireLogin: false,
            index: 1 //判断index来决定页面的层级
          },
        },
        {
          name: 'IndexTheme',
          path: 'index_theme',
          component: () => import('../views/index/IndexTheme'),
          meta: {
            title: '主题系列',
            requireLogin: false,
            index: 1 //判断index来决定页面的层级
          },
        },

      ],
    },
    {
      name: 'About',
      path: '/about',
      component: () => import('../views/index/About'),
      meta: {
        title: '关于「积木小站」',
        requireLogin: false,
        //keepAlive: true,
        index: 2 //判断index来决定页面的层级
      }
    },
    // {
    //   name: 'Search',
    //   path: '/search',
    //   component: () => import('../views/index/Search'),
    //   meta: {
    //     title: '搜索',
    //     requireLogin: false,
    //   }
    // },
    //================================== 套组搜索
    {
      name: 'SearchSet',
      path: '/searchset',
      component: () => import('../views/set/SearchSet'),
      meta: {
        title: '搜索套组',
        requireLogin: false,
        keepAlive: true,
        index: 1 //判断index来决定页面的层级
      }
    },
    // {
    //   name: 'GoodsList',
    //   path: '/goodslist',
    //   component: () => import('../views/goods/GoodsList'),
    //   meta: {
    //     title: '商品列表',
    //     requireLogin: false,
    //     keepAlive: true
    //   }
    // },
    //================================== 套组详情

    {
      name: 'SetIndex',
      path: '/set/:brand/:setnumber',
      //alias: ['/set/:id(\\d+)'],
      component: () => import('../views/set/SetIndex'),
      meta: {
        title: '套组详情',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },

    {
      name: 'SetIndexById',
      path: '/set/:id(\\d+)',
      component: () => import('../views/set/SetIndex'),
      meta: {
        title: '套组详情',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },

    {
      name: 'SetGoshopping',
      path: '/shopping/:id(\\d+)',
      component: () => import('../views/set/SetGoshopping'),
      meta: {
        title: '前往商城',
        requireLogin: false,
        //keepAlive: true
        index: 3 //判断index来决定页面的层级
      }
    },

    {
      name: 'RetiringSoon',
      path: '/retiring_soon',
      component: () => import('../views/set/RetiringSoon'),
      meta: {
        title: '即将绝版',
        requireLogin: false,
        keepAlive: true,
        index: 3 //判断index来决定页面的层级
      }
    },

    {
      name: 'Brickheadz',
      path: '/brickheadz',
      component: () => import('../views/set/Brickheadz'),
      meta: {
        title: '乐高方头仔汇总',
        requireLogin: false,
        keepAlive: true,
        index: 3 //判断index来决定页面的层级
      }
    },



    //================================== 品牌详情

    {
      name: 'BrandIndex',
      path: '/brand/:id(\\d+)',
      component: () => import('../views/brand/BrandIndex'),
      meta: {
        title: '品牌详情',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },

    //================================== 查看链接

    {
      name: 'Goto',
      path: '/goto',
      component: () => import('../views/Goto/Index'),
      meta: {
        //title: '前往',
        requireLogin: false,
        //keepAlive: true
        index: 3 //判断index来决定页面的层级
      }
    },


    //================================== 影视

    {
      name: 'MovieIndex',
      path: '/movie',
      component: () => import('../views/movie/MovieIndex'),
      meta: {
        title: '影视',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },

    //================================== 导购 帮你挑一套积木

    {
      name: 'GuideIndex',
      path: '/guide',
      component: () => import('../views/guide/GuideIndex'),
      meta: {
        title: '帮你挑一套积木',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },
    //================================== 地标

    {
      name: 'LandmarkMap',
      path: '/landmarkmap',
      component: () => import('../views/landmarkmap/LandmarkMap'),
      meta: {
        title: '地标地图',
        requireLogin: false,
        keepAlive: true,
        index: 2 //判断index来决定页面的层级
      }
    },

    //================================== 零件

    {
      name: 'BrickColor',
      path: '/brick_color',
      component: () => import('../views/brick/BrickColor'),
      meta: {
        title: '颜色',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },

    {
      name: 'Dict',
      path: '/dict',
      component: () => import('../views/brick/Dict'),
      meta: {
        title: '词汇表',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },

    //================================== 其他
    // {
    //   path: '*',
    //   redirect: '/'
    // },


    {
      name: 'NinjagoFonts',
      path: '/ninjago_fonts',
      component: () => import('../views/tools/NinjagoFonts'),
      meta: {
        title: '幻影忍者Ninjago文字翻译机',
        requireLogin: false,
        //keepAlive: true
        index: 2 //判断index来决定页面的层级
      }
    },









  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if( to.hash ){
        return {
          selector: to.hash
        }
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js